var taildefault = null;
/* General theme js */
var taildefault = null;
jQuery(document).ready(function($){
    //Init tail.select
    //Only init tail select if browser isn't IE
    if (!window.document.documentMode) {
        taildefault = tail.select(".tail-select", { 
            openAbove: false,
            width: "100%",
            height: 160 
        });
    }
    // Milkman search
    $('#address-search').on('input', function() { 
        $(".search-results").removeClass("d-none");
        $(".signup").prop("disabled",true);
    });
    $(".search-result").on('click', function() { 
        $('#address-search').val($(this).text());
        $(".signup").prop("disabled",false);
        $(".search-results").addClass("d-none");
    }); 
    $(".eircode-finder").on('click', function() { 
        var win = window.open('https://finder.eircode.ie/#/', '_blank');
        if (win) {
            win.focus();
        } else {
            alert('Please go to https://finder.eircode.ie');
        }        
    }); 
    $('html').click(function(e) {    
        $(".signup").prop("disabled",false);
        $(".search-results").addClass("d-none");        
    });


    $('#delivery-note').on('input',function(e){
        $(this).addClass('bgblue');
        $('.btn-save').removeClass('d-none');

        if( $(this).val().length === 0 ) {
            $(this).removeClass('bgblue');
            $('.btn-save').addClass('d-none');
        }
        
        var len = this.value.length;
        if (len >= 500) {
            this.value = this.value.substring(0, 500);
        } else {
            $('#charNum').text(500 - len);
        }      
    });    

    //View / hide password
    $(".view-password").click(function() {

        $(this).toggleClass("hide-pass");
        var input = $($(this).attr("toggle"));
        if (input.attr("type") == "password") {
          input.attr("type", "text");
        } else {
          input.attr("type", "password");
        }
      });

    // Payment / billing form
    $('#billing-details').click(function() {
        $(".billing-details").toggleClass("d-none");
        $(".billing-details-form").toggleClass("d-none");
    });
    $('#billing-address').click(function() {
        $(".billing-address").toggleClass("d-none");
        $(".billing-address-form").toggleClass("d-none");
    });    
    var prodqty;
    var prodedit;
    var prodcheck;
    var saveitem;
    var edititem;      

    // Plus-Minus form input
    $('[data-quantity="plus"]').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }   
        saveitem = $(this).closest('li').find('.save-item');
        edititem = $(this).closest('li').find('.edit-item');
        $(saveitem).show();
        $(edititem).hide();
    });
    // This button will decrement the value till 0
    $('[data-quantity="minus"]').click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        var fieldName = $(this).attr('data-field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
        saveitem = $(this).closest('li').find('.save-item');
        edititem = $(this).closest('li').find('.edit-item');
        $(saveitem).show();
        $(edititem).hide();        
        
    });
    // END Plus-Minus

    /* edit order */
    $('.edit-item').click(function(e) {
        e.preventDefault();  
        $(this).addClass('disabled');
        $(this).siblings('.add-item').hide();
        $(this).siblings('.cancel-item').show();
        prodqty = $(this).parent().parent().find('.prod-qty');
        prodedit = $(this).parent().parent().find('.prod-edit');
        prodcheck = $(prodedit).find("[type=checkbox]");
        $(prodedit).show();
        $(prodqty).addClass("cart-view");
        $(prodcheck).on('change', function() {
            saveitem = $(this).closest('li').find('.save-item');
            edititem = $(this).closest('li').find('.edit-item');
            $(saveitem).show();
            $(edititem).hide();               
        });
    });

    $('.cancel-item').click(function() {
        $(this).hide();
        $(this).siblings('.edit-item').show().removeClass('disabled');
        $(this).siblings('.save-item').hide();
        $(this).siblings('.add-item').show();
        $(prodedit).hide(); 
        $(prodqty).removeClass("cart-view");
    });    

    $('.save-item').click(function() {
        $(this).siblings('.edit-item').show().removeClass('disabled');
        $(this).siblings('.add-item').show();
        $(this).siblings('.cancel-item').hide();
        $(prodedit).hide(); 
        $(this).hide();
        $(prodqty).removeClass("cart-view");
    });
/*
    $('.icon-edit').click(function() {
        $(this).parent().siblings().children().prop("disabled", false);
    });
*/
    $('.howoften button').click(function() {
        $('.howoften').hide();
        $('.chooseqty').show();
    });       


    // SWIPER JS
    var swiper = new Swiper('.hero-signup', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            delay: 5000,
          },
        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },        
    });

    var swiper = new Swiper('.promo-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            nextEl: '.cat-next',
            prevEl: '.cat-prev',
          },       
    });    

    var swiper = new Swiper('.category-swiper', {
        slidesPerView: 6,
        spaceBetween: 6, 
        freeMode: true,
        navigation: {
            nextEl: '.cat-next',
            prevEl: '.cat-prev',
          },
        breakpoints: {
            320: {
            slidesPerView: 3.3,
            spaceBetween: 6
            },
            480: {
            slidesPerView: 6,
            spaceBetween: 10
            },            
        },
        on: {
            click: function (swiper, e) {
                if(typeof swiper.clickedIndex != 'undefined'){
                    swiper.slideTo(swiper.clickedIndex-1);
                }
            },
          }
    });

    var swiper = new Swiper('.promo-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10, 
        navigation: {
            nextEl: '.promo-next',
            prevEl: '.promo-prev',
          },
        
    });      

    var swiper = new Swiper('.milk-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10, 
        navigation: {
            nextEl: '.milk-next',
            prevEl: '.milk-prev',
          },
        
    });    
      

    var swiper = new Swiper('.supermilk-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10, 
        navigation: {
            nextEl: '.milk-next',
            prevEl: '.milk-prev',
          },
    });        

    $(".datepicker").flatpickr();

    var fp = flatpickr(".datepicker", {
        inline: true,
        mode: "range",
        minDate: "today",
        maxDate: new Date().fp_incr(28), // 28 days from now    
        defaultDate: new Date(),   
        onChange: function(dates) {
            if (dates.length == 2) {
                var start = dates[0];
                var end = dates[1];
                $('#startdate').html(start);
                $('#enddate').html(end);
            }
        }        
    })    
    $(".scrollTop").click(function() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
      }); 
});

